module.exports = __webpack_public_path__ + "static/media/logo-3d-ovato-logo-new.2e6654e7.pdf";